<template>
  <div>
    <div>
      {{ $t('mobileLandingPage.wait') }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';
axios.defaults.withCredentials = true;

export default {
  name: 'mobileLandingPage',
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.recursiveLogOut();
  },
  methods: {
    ...mapActions(['logout', 'mobileCollectionLogin']),
    recursiveLogOut() {
      this.logout()
        .then(response => {
          if (response) {
            //recursively check to see if actually logged out due to quirk of Yii
            this.$store
              .dispatch('checkUserToken', true)
              .then(response => {
                let vm = this;
                setTimeout(function() {
                  if (response !== -1) {
                    vm.recursiveLogOut();
                  } else {
                    const params = {
                      username: vm.$route.query.username,
                      assessmentID: vm.$route.query.assessmentID,
                      loginKey: vm.$route.query.loginKey,
                    };
                    const formUrl = vm.$route.query.formUrl;
                    vm.collectionLogin(params, formUrl, 1);
                  }
                }, 250)
              })
              .catch(err => {
                this.recursiveLogOut();
              });
          }
        })
        .catch(err => {
          this.$router.push({
            name: 'mobileLogoutPage',
            params: {
              mobileCloseDialog: 'Sorry there was an error. Please press close/x then try again. Error code: 2',
            },
          });
        });
    },
    collectionLogin(params, formUrl, count) {
        let vm = this;
        vm.mobileCollectionLogin(params)
            .then(response => {
            if (response.success) {
                if (formUrl) {
                vm.$router
                    .push({
                        path: formUrl,
                        query: { fromMobile: true },
                    })
                    .catch(err => {
                        vm.$router.push({
                            name: 'mobileLogoutPage', 
                            params: {
                                mobileCloseDialog: 'Sorry there was an error. Please try again later. Error code: 3',
                            }
                        });
                    });
                }
            } else {
                vm.$router.push({
                    name: 'mobileLogoutPage', 
                    params: {
                        mobileCloseDialog: 'Sorry there was an error. Please try again later. Error code: 4',
                    }
                });
            }
            })
            .catch(err => {
                // intermittent network error possibly caused by http1.1 comes here, so we try and log in again.
                if (count <= 5) {
                    this.collectionLogin(params, formUrl, count + 1)
                } else {
                    vm.$router.push({
                        name: 'mobileLogoutPage', 
                        params: {
                            mobileCloseDialog: 'Sorry there was an error. Please try again later. Error code: 5',
                        }
                    });
                }
            });
    },
  },
};
</script>
